export default __webpack_public_path__ + "static/media/trending_up.2df9f6ad.svg";